import AppController from './app.controller';
import routeConfig from './app.routes';

const AppComponent = {
	template: '<ng-outlet></ng-outlet>',
	controller: AppController,
	$routeConfig: routeConfig,
	bindings: {
		$router: '<'
	}
};

export default AppComponent;
